import {useState} from 'react';
import {SoopLoading, SoopPagination} from '@soop-ui/soop-ui';
import {useGetMyInquiryList} from '@/hooks/help';
import Title from '@/components/help/common/Title';
import InquiryItem from './InquiryItem';
import EmptyBoard from '../../common/EmptyBoard';
import styles from './MyInquiry.module.scss';

const HelpMyInquiry = () => {
  const [page, setPage] = useState(1);
  const {data, isLoading, refetch} = useGetMyInquiryList({page});
  const {inquiryList, totalPages, currentPage} = data || {
    inquiryList: [],
    totalPages: 0,
    currentPage: 0,
  };

  const changePcPage = (page: number) => {
    setPage(page);
  };

  return (
    <>
      <Title title='나의 문의/신고내역' align='left' />
      <div className={styles.MyInquiryWrapper}>
        <div className={styles.MyInquiryBoard}>
          <div className={styles.ListHeader}>
            <div className={styles.ListType}>종류</div>
            <div className={styles.ListTitle}>제목</div>
            <div className={styles.ListAnswer}>답변 상태</div>
            <div className={styles.ListEvaluation}>답변 평가</div>
            <div className={styles.ListDate}>문의 일자</div>
          </div>
          <div className={styles.ListCont}>
            {isLoading ? (
              <SoopLoading />
            ) : inquiryList.length > 0 ? (
              <ul>
                {inquiryList.map((item) => (
                  <InquiryItem
                    key={item.id}
                    {...item}
                    onSurveySuccess={refetch}
                  />
                ))}
              </ul>
            ) : (
              <EmptyBoard type='myInquiry' />
            )}
          </div>
        </div>
        {totalPages > 1 && (
          <SoopPagination
            currentPage={currentPage}
            totalPages={totalPages}
            align='center'
            onPageChange={changePcPage}
          />
        )}
      </div>
    </>
  );
};

export default HelpMyInquiry;
